import {
  InfoIcon,
  Input,
  Label,
  LinkIcon,
  Tooltip,
} from "@monsterindia/global-ui-components";
import {
  FieldErrors,
  FieldValues,
  UseFormRegister,
  UseFormSetError,
  UseFormSetValue,
} from "react-hook-form";

import { LINKEDIN_REGEX } from "../../../../validations/Regex";

type LinkedinURLProps = {
  register: UseFormRegister<FieldValues>;
  setValue: UseFormSetValue<FieldValues>;
  errors: FieldErrors<FieldValues>;
  setError: UseFormSetError<FieldValues>;
  clearError: () => void;
};

export const LinkedinURL = ({
  register,
  setValue,
  errors,
  setError,
  clearError,
}: LinkedinURLProps) => {
  const ToolTipContent = () => (
    <ul className="l1-list-disc l1-pl-4 l1-pr-2 l1-text-[10px] l1-leading-[1.3]">
      <li>Log into your LinkedIn account on browser</li>
      <li>Open your profile page</li>
      <li>Copy the web address URL and paste here</li>
    </ul>
  );

  const handleBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    const value = e.target.value;

    if (!value) {
      clearError();
      return;
    }

    // www.linkedin.com/in/your-id?trk=profile-badge || www.linkedin.com/in/your-id
    // remove ?trk=profile-badge from the URL if present
    const linkedinUrl = value.split("?")[0];
    if (linkedinUrl !== value) {
      e.target.value = linkedinUrl;
      setValue("linkedin", linkedinUrl);
    }

    const isInputValid = LINKEDIN_REGEX.test(linkedinUrl);

    if (!isInputValid) {
      setError("linkedin", {
        type: "manual",
        message: "Enter a valid LinkedIn URL",
      });
    } else {
      clearError();
    }
  };

  return (
    <Label
      labelText="Share your LinkedIn Profile URL"
      isRequired={false}
      className="!l1-text-sm"
      tooltip={
        <Tooltip
          placement="top"
          content={<ToolTipContent />}
          icon={<InfoIcon width={16} height={16} />}
        />
      }
    >
      <Input
        id="linkedin"
        placeholder="www.linkedin.com/in/your-id"
        leftIcon={<LinkIcon width={13} height={13} />}
        {...register("linkedin", {
          pattern: {
            value: LINKEDIN_REGEX,
            message: "Invalid linkedin url",
          },
          onBlur: (e: React.ChangeEvent<HTMLInputElement>) => handleBlur(e),
        })}
        errorText={errors.linkedin ? "Enter a valid LinkedIn URL" : ""}
      />
    </Label>
  );
};
